import { getDayBottomElements } from './get-day-bottom-elements';
import { getDayFormattedTimeframes } from './get-day-formatted-timeframes';
import { getDayTimeframes } from './get-day-timeframe';
import { getDayTopElements } from './get-day-top-elements';
import { TTimelineColumns } from './timeline-timeframes';

// --------------------------------------------------
// --------------------- DAY ------------------------
// --------------------------------------------------

export function setDay(from: Date, to: Date): TTimelineColumns {
  return {
    topWidth: 343,
    bottomWidth: 49,

    topElements: getDayTopElements(from, to),
    bottomElements: getDayBottomElements(from, to),
    timeframes: getDayTimeframes(from, to),
    formattedTimeframes: getDayFormattedTimeframes(from, to),
  };
}
